import "./GroupFilter.css";

const GroupFilter = (props: any) => {
  return props.filters.map((item: any) => (
    <div className="groupFilter">
      <span>{item}</span>
      <img
        className="groupFilterImage"
        src="Dismiss.png"
        alt="dismiss"
        onClick={() => {
          props.onDelete(item);
        }}
      />
    </div>
  ));
};

export default GroupFilter;
